const initialState = {
  productDetail: {},
  productDocDetail: [],
  productCoverImg: [],
  productThumbnailImg: [],
  productTermsConditionsDoc: [],
  productVideos: [],
  multimediaImages: [],
  productVideosLinks: [],
  updateRevRatRes: [],
  deleteRevRes: [],
  endpointRes: {},
  grantTypeReqAttr: [],
  tokenResponse: {},
  tokenErrorResponse: {},
  applicationOfUsers: [],
  mssApiAccessToken: '',
  baseUrl: '',
  billingCycleMasterData: {},
  sendMail: undefined,
  emailStatus: '',
  replyCommentText: {},
  downloadedFile: [],
  productDocList: [],
  totalProductQty: -1,
  selectedProductQty: 1,
  productDisplayNames: [],
  highlightsDocument: [],
  userTermsConsent: ''
};

const ProductDetailReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_PRODUCT_BY_ID':
      return {
        ...state,
        productDetail: action.payload,
        endpointRes: ''
      };
    case 'GET_PRODUCT_DOCS_BY_ID':
      return { ...state, productDocDetail: action.payload };
    case 'GET_PRODUCT_COVER_IMG':
      return { ...state, productCoverImg: action.payload };
    case 'GET_PRODUCT_THUMBNAIL_IMG':
      return { ...state, productThumbnailImg: action.payload };
    case 'GET_TERMS_CONDITIONS_DOCUMENT':
      return {
        ...state,
        productTermsConditionsDoc: action.payload
      };
    case 'GET_PRODUCT_VIDEOS_BY_ID':
      return { ...state, productVideos: action.payload };
    case 'GET_PRODUCT_MULTIMEDIA_IMG_BY_ID':
      return { ...state, multimediaImages: action.payload };
    case 'GET_PRODUCT_VIDEOS_LINK_BY_ID':
      return { ...state, productVideosLinks: action.payload };
    case 'GET_DOWNLOAD_SAMPLE_DATA':
      return { ...state, downloadedFile: action.payload };
    case 'CLEAR_PRODUCT_DOC_LIST':
      return { ...state, productDocList: action.payload };
    case 'GET_DOWNLOAD_PRODUCT_DOC_LIST':
      return {
        ...state,
        productDocList: state.productDocList.concat(action.payload)
      };
    case 'RESET_PRODUCT_DOCS':
      return {
        ...state,
        productDocDetail: [],
        productCoverImg: [],
        productThumbnailImg: [],
        productVideos: [],
        multimediaImages: [],
        productVideosLinks: [],
        highlightsDocument: [],
        productTermsConditionsDoc: []
      };
    case 'WSO_RESPONSE':
      return { ...state, endpointRes: action.payload };
    case 'GET_GRANTTYPE_REQ_ATTR':
      return { ...state, grantTypeReqAttr: action.payload };
    case 'CLIENT_AUTH_ACCESS_TOKEN':
      return {
        ...state,
        tokenResponse: action.payload,
        tokenErrorResponse: {}
      };
    case 'ACCESS_TOKEN_ERROR':
      return {
        ...state,
        tokenResponse: {},
        tokenErrorResponse: action.payload
      };
    case 'ERR_FAILED':
      return {
        ...state,
        tokenResponse: {},
        tokenErrorResponse: {}
      };
    case 'USER_APPLICATION':
      return {
        ...state,
        applicationOfUsers: action.payload,
        mssApiAccessToken: ''
      };
    case 'GET_MSSAPIACCESS_TOKEN':
      return { ...state, mssApiAccessToken: action.payload };
    case 'BASE_URL':
      return { ...state, baseUrl: action.payload };
    case 'GET_BILLING_CYCLE_MASTER_DATA':
      return {
        ...state,
        billingCycleMasterData: {
          ...action.payload,
          rateLimitTypes: action.payload?.rate_limit
        }
      };
    case 'SEND_EMAIL':
      return { ...state, sendMail: action.payload };
    case 'SEND_EMAIL_WITH_KEY_BODY':
      return { ...state, emailStatus: action.payload };
    case 'CLEAR_PRODUCT_QTY':
      return { ...state, totalProductQty: action.payload };
    case 'GET_PRODUCT_QTY':
      return {
        ...state,
        totalProductQty: action.payload.quantity
      };
    case 'CLEAR_PRODUCT_DISPLAY_NAMES':
    case 'GET_PRODUCT_DISPLAY_NAMES':
      return {
        ...state,
        productDisplayNames: action.payload
      };
    case 'SET_PRODUCT_QUANTITY':
      return { ...state, selectedProductQty: action.payload };
    case 'GET_HIGHLIGHTS_DOCUMENT':
      return { ...state, highlightsDocument: action.payload };
    case 'GET_CONSENT':
      return { ...state, userTermsConsent: action.payload };
    case 'POST_CONSENT':
      return { ...state, userTermsConsent: action.payload };
    default:
      return state;
  }
};

export default ProductDetailReducer;
